import { createStore, combineReducers } from "redux";
import { localeReducer, initialize } from "react-localize-redux";

const store = createStore(combineReducers({
	locale: localeReducer
}));

const languages = [
	"de",
	"en"
];

store.dispatch(initialize(languages, {
	defaultLanguage: "de"
}));

export default store;



// WEBPACK FOOTER //
// ./src/store.js